import { useTranslation } from 'react-i18next';

import { Stack } from '@/shared/ui';
import { CustomTypography } from '@/shared/ui/Typography';

import { FullPrice, Row, SummaryContainer, TotalTitle } from './styles';

type BillingSummaryProps = {
  totalPrice: number;
  fullPrice: number;
};

export const TariffSummary = ({
  totalPrice,
  fullPrice,
}: BillingSummaryProps) => {
  const hasDiscount = fullPrice > totalPrice;
  const { t } = useTranslation();
  return (
    <SummaryContainer>
      <Row>
        <TotalTitle variant="h4">{t('billing:payment.total')}</TotalTitle>
        <Stack direction="row" alignItems="baseline" gap={1}>
          {hasDiscount && (
            <FullPrice variant="h6">{fullPrice.toLocaleString()} ₽</FullPrice>
          )}
          <CustomTypography variant="h6">
            {totalPrice.toLocaleString()} ₽
          </CustomTypography>
        </Stack>
      </Row>
    </SummaryContainer>
  );
};
